/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 *
 */

let webUrl = ''
let routerMode = 'hash';
let protocol = window.location.protocol + '//';
if (process.env.NODE_ENV == 'development') {//本地开发
  webUrl = protocol+'manage.133.cn/';
} else if (process.env.NODE_ENV == 'testing') {//测试环境
  webUrl =protocol+'api-manage.data.com:8080/';
} else if (process.env.NODE_ENV == 'production') {//生产环境
  webUrl = protocol+'manage.133.cn/';
}
let baseUrl = webUrl; //可能拼接
export {
  baseUrl,
  routerMode,
  webUrl
}



// WEBPACK FOOTER //
// ./src/config/env.js